import {useSettings} from 'yoshi-flow-editor-runtime/tpa-settings/react'
import React from 'react'
import {ChevronRight} from 'wix-ui-icons-common'
import Location from 'wix-ui-icons-common/LocationSmall'
import {TEXT_BUTTON_PRIORITY, TextButton} from 'wix-ui-tpa/TextButton'
import {DH} from '../../../data-hooks'
import settingsParams from '../../../settingsParams'
import {Tags} from '../../filters/tags'
import {ItemDivider} from '../divider'
import {Time} from '../time'
import {getScheduleItemDescription} from '../../../selectors/schedule'
import * as s from './mobile.scss'
import {classes} from './mobile.st.css'
import type {ItemProps} from '.'

export const MobileItem = ({item, showDivider, toggleScheduleItemModal, readDescriptionClicked, t}: ItemProps) => {
  const settings = useSettings()
  const showDuration = settings.get(settingsParams.showDuration)
  const descriptionButtonText = settings.get(settingsParams.readMore)
  const description = getScheduleItemDescription(item)

  const handleReadMore = () => {
    readDescriptionClicked({itemId: item.id})
    toggleScheduleItemModal(item)
  }

  return (
    <li>
      <div className={s.container} data-hook={DH.MOBILE_SCHEDULE_ITEM}>
        <Time className={s.timeSlot} data-hook={DH.SCHEDULE_ITEM_DATETIME} dateTime={item.formattedTimeSlot}>
          {item.formattedTimeSlot}
        </Time>
        {showDuration && (
          <div className={s.duration} data-hook={DH.SCHEDULE_ITEM_DURATION}>
            {item.formattedDuration}
          </div>
        )}
        <div className={s.title} data-hook={DH.SCHEDULE_ITEM_NAME}>
          {item.name}
        </div>
        {item.location && (
          <div className={s.location} data-hook={DH.LOCATION}>
            <Location data-hook={DH.LOCATION_ICON} />
            <span>{item.location}</span>
          </div>
        )}
        {item.tags && <Tags t={t} tags={item.tags} className={s.tags} />}
        {description && (
          <TextButton
            className={classes.readMore}
            priority={TEXT_BUTTON_PRIORITY.primary}
            data-hook={DH.DESCRIPTION_BUTTON}
            suffixIcon={<ChevronRight />}
            onClick={handleReadMore}
          >
            {descriptionButtonText}
          </TextButton>
        )}
      </div>
      {showDivider && <ItemDivider />}
    </li>
  )
}
